import { gql } from '@apollo/client'

export const ROOMTYPE_MODIFY_MUTATION = gql`
  mutation ModifyRoomType(
    $input: RoomTypeInput!
    $propertyCode: String!
    $roomTypeCode: String!
  ) {
    modifyRoomType(
      input: $input
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
    ) {
      message
    }
  }
`

export const ROOMTYPE_MODIFY_ACTIVE_MUTATION = gql`
  mutation ModifyActiveRoomType(
    $propertyCode: String!
    $roomTypeCode: String!
    $active: Boolean!
  ) {
    modifyActiveRoomType(
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
      active: $active
    ) {
      message
    }
  }
`
